import { Component, OnInit } from '@angular/core';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-oppo-egypt2021',
  templateUrl: './oppo-egypt2021.component.html',
  styleUrls: ['./oppo-egypt2021.component.scss']
})
export class OppoEgypt2021Component implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle('Oppo Reno 6 Cup (Season 2)')

  }

  ngOnInit(): void {
  }

}
